const state = {   
    errorMessage: '',
    rlEntry: {
      images: {
        data: []
      }
    },
    itemsDashboard: [
      {name: 'Prices', role: 'PBI Report 4', icon: 'flip_to_front', to: '/prices-dashboard', imgUrl: require("@/assets/PBIReport4.png"), pbiToken: 4, inDashboard: true},
      {name: 'Forecast', role: 'PBI Report 3', icon: 'insights', to: '/forecast-dashboard', imgUrl: require("@/assets/PBIReport3.png"), pbiToken: 3,inDashboard: true},
      {name: 'Monthly Exp/Imp', role: 'PBI Report 6', icon: 'polymer', to: '/monthly-export-dashboard', imgUrl: require("@/assets/PBIReport6.png"), pbiToken: 6, inDashboard: true},
      {name: 'Collection', role: 'PBI Report 2', icon: 'dashboard', to: '/collection-dashboard', imgUrl: require("@/assets/PBIReport2.png"), pbiToken: 2, inDashboard: true },
      {name: 'Treatment', role: 'PBI Report 5', icon: 'group_work', to: '/treatment-dashboard', imgUrl: require("@/assets/PBIReport5.png"), pbiToken: 5, inDashboard: true},
      {name: 'Market Insights', role: 'PBI Report 1', to: '/insights-dashboard', imgUrl: require("@/assets/PBIReport1.png"), pbiToken: 1, inDashboard: false},
      {name: 'Packaging', role: 'PBI Report 7', icon: 'inventory_2', to: '/packaging-waste', imgUrl: require("@/assets/PBIReport7.png"), pbiToken: 7, inDashboard: true},
      {name: 'Daily Report - Paper', role: 'PBI Report 8', icon: 'article', to: '/daily-report-paper', imgUrl: require("@/assets/PBIReport8.png"), pbiToken: 8, inDashboard: true},
      {name: 'Daily Report - Plastic', role: 'PBI Report 9', icon: 'article', to: '/daily-report-plastic', imgUrl: require("@/assets/PBIReport9.png"), pbiToken: 9, inDashboard: true},
      {name: 'Market Trends', role: 'PBI Report 10', icon: 'article', to: '/market-trends', imgUrl: require("@/assets/PBIReport10.png"), pbiToken: 10, inDashboard: true}
    ],
    rlImageCloseDialog: {show: false, close: false},
    rlImageSaveDialog: {show: false, save: false, item: {shownImages: [], savedImages: []} },
    rlEntryAddDialogView2: {show: false, item: {}},
    rlEditNote: {show: false, alert: {show: false, type: null, icon: null, message: null}},
    rlEntryList: {data: [], total: null},
    rlEntryTable: {loading: true},
    rlEntryTableOptions: {page: 1, itemsPerPage: 50, sortBy: ['trans_date'], sortDesc: [true], filters: {}},
    rlAddDialog: {show: false, alert: {show: false, type: null, icon: null, message: null}},
    rlAddDialogList: [],
    rlEditDialog: {show: false, alert: {show: false, type: null, icon: null, message: null}},
    rlDeleteDialog: {show: false, alert: {show: false, type: null, icon: null, message: null}},
    rlImageAddDialog: {show: false, item: {images: []}},
    rlImageEditDialog: {show: false, alert: {show: false, type: null, icon: null, message: null}, images: []},
    rlImageFullSizeDialog: {show: false, imgUrl: null},
    rlDialogRules: {
      required: [
        v => !!v || 'The field is required',
      ],
      requiredArray: [
        v => v.length > 0 || 'The field is required',
      ],
      money: [
        v => (v || '').length == 0 || !isNaN(v) || "Must be a number",
        v => (v || '').length == 0 || parseFloat(v) >= 0 || 'Min value is 0',
        v => (v || '').length == 0 || parseFloat(v) < 1000000000 || 'Max value is 999999999.99'
      ],
      percentage: [
        v => (v || '').length == 0 || !isNaN(v) || 'Must be a number',
        v => (v || '').length == 0 || parseFloat(v) >= 0 || 'Min percentage is 0%',
        v => (v || '').length == 0 || parseFloat(v) <= 100 || 'Max percentage is 100%'
      ],
      specification: [
        v => /^1?\d?\d\/\d\d?0?/.test(v) && (v || '').length <= 5 || 'Specification must be in one of the formats **/** or */*** or ***/*',
        v => {
          if((v || '').length >= 1) {
            const temp = v.split('/')
            return parseInt(temp[0], 10) + parseInt(temp[1], 10) === 100 || 'Specification must add up to 100'
          }
          return false
        }
      ],
      isInteger: [
        v => Number.isInteger(Number(v)) || "The value must be an integer number"
      ],
      integer: [
        v => (v || '').length == 0 || !isNaN(v) || "Must be a number",
      ],
      integerOneOrTwo: [
        v => v == 1 || v == 2 || "Must be group 1 or 2"
      ],
      stringSize2: [
        v => (v || '').length == 2 || 'Must be 2 characters'
      ],
      stringSize3: [
        v => (v || '').length == 3 || 'Must be 3 characters'
      ],
      stringMax5: [
        v => (v || '').length <= 5 || 'Max 5 characters'
      ],
      stringMax20: [
        v => (v || '').length <= 20 || 'Max 20 characters'
      ],
      stringMax30: [
        v => (v || '').length <= 30 || 'Max 30 characters'
      ],
      stringMax36: [
        v => (v || '').length <= 36 || 'Max 36 characters'
      ],
      stringMax50: [
        v => (v || '').length <= 50 || 'Max 50 characters'
      ],
      stringMax100: [
        v => (v || '').length <= 100 || 'Max 100 characters'
      ],
      stringMax255: [
        v => (v || '').length <= 255 || 'Max 255 characters'
      ],
      boolean1: [
        v => v == 1 || "Must be accepted"
      ],
      email: [
        v => {
          const temp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return temp.test(v) || 'Invalid e-mail address'
        }
      ],    
    },
    user: null,
    loginAlert: {show: false, type: null, icon: null, message: null},
    licenseList: [],
    roleList: [],
    permissionList: [],
    entryTypeList: [],
    materialList: [],
    gradeList: [],
    incotermList: [],
    currencyList: [],
    hs2List: [],
    domesticCompanyList: [],
    shippingCompanyList: [],
    inspectionCompanyList: [],
    countryList: [],
    unitOfMeasureList: [],
    recyclingLedgerEntryList: [],
    companyList: [],
    pbiReportList: [],
    pbiTokenList: [],
    showVerificationMessage: false
}

export default state;